import { useRef, useEffect } from 'react';
import MinicartProvider from './hooks/useMinicart';

import { MinicartProps } from './@types/MinicartProps';
import MinicartWrapperContainer from './handles/MinicartWrapperContainer';
import MinicartContainer from './handles/MinicartContainer';
import OpenIconContainer from './handles/OpenIconContainer';
import MinicartIconContainer from './handles/MinicartIconContainer';
import MinicartQuantityBadge from './handles/MinicartQuantityBadge';

import './Minicart.scss';
import Drawer from './handles/Drawer';
import DrawerContent from './handles/DrawerContent';
import CloseIconContainer from './handles/CloseIconContainer';
import ChildrenContainer from './handles/ChildrenContainer';
import MinicartSideBarContentWrapper from './handles/MinicartSideBarContentWrapper';
import Overlay from './handles/Overlay';
import { Portal } from '@chakra-ui/react';
import OpenMinicartContextProvider, { useOpenMinicartContextProvider } from '../openMinicartContextProvider';

const Minicart = (props: MinicartProps) => {
	return (
		<OpenMinicartContextProvider>
			<MinicartProvider {...props}>
				<MinicartWrapperContainer>
					<MinicartContainer>
						<OpenIconContainer>
							<MinicartIconContainer>
								<svg
									fill="none"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									className="vtex-minicart-2-x-cartIcon"
									xmlns="http://www.w3.org/2000/svg"
								>
									<use href="#hpa-cart"></use>
								</svg>
								<MinicartQuantityBadge>3</MinicartQuantityBadge>
							</MinicartIconContainer>
						</OpenIconContainer>
					</MinicartContainer>
				</MinicartWrapperContainer>
				<MinicartPortalWrapper {...props} />
			</MinicartProvider>
		</OpenMinicartContextProvider>
	);
};

const MinicartPortalWrapper = (props: any) => {
	const { isOpen, setIsOpen } = useOpenMinicartContextProvider();
	const canvasRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const iframe = document.querySelector('iframe')?.contentDocument;
		canvasRef.current = iframe?.querySelector('.canvas') || document.querySelector('.canvas');
	}, []);

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	return (
		<Portal containerRef={canvasRef}>
			{isOpen && <Overlay handleClick={handleClick} />}
			<Drawer isOpen={isOpen}>
				<DrawerContent>
					{props.children}
					<CloseIconContainer handleClick={handleClick} />
					<ChildrenContainer>
						<MinicartSideBarContentWrapper>
							<></>
						</MinicartSideBarContentWrapper>
					</ChildrenContainer>
				</DrawerContent>
			</Drawer>
		</Portal>
	);
};

export default Minicart;
